var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7801 8.52921C16.7781 7.87142 16.7223 7.39157 16.6029 6.89413L8.93896 6.91699L8.94782 9.88594L13.4464 9.87252C13.3579 10.6106 12.8715 11.7232 11.7853 12.4731L11.7703 12.5726L14.199 14.4052L14.367 14.4211C15.9046 13.0209 16.7874 10.9648 16.7801 8.52921Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96654 16.3746C11.1705 16.368 13.0186 15.6513 14.3663 14.4206L11.7847 12.4726C11.0968 12.9458 10.1726 13.2775 8.95732 13.2811C6.79872 13.2875 4.96248 11.8974 4.30364 9.97043L4.20793 9.97869L1.69395 11.8974L1.66127 11.9873C3.01137 14.5967 5.77395 16.3841 8.96654 16.3746Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30337 9.9702C4.12957 9.47293 4.02825 8.93983 4.0266 8.38873C4.02496 7.83757 4.1231 7.30394 4.28487 6.80567L4.27999 6.69967L1.72295 4.7654L1.63959 4.80457C1.08959 5.89071 0.775782 7.10949 0.779627 8.39842C0.783471 9.68734 1.10455 10.9042 1.66101 11.987L4.30337 9.9702Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92779 3.46832C10.4606 3.46375 11.4964 4.10957 12.0876 4.65009L14.3847 2.4387C12.966 1.15399 11.1225 0.368344 8.91856 0.374917C5.72598 0.38444 2.97413 2.18826 1.63962 4.80566L4.28489 6.80676C4.94129 4.87584 6.7692 3.47476 8.92779 3.46832Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.45efd72b33a367e823833e7c184921da.svg";
export { ForwardRef as ReactComponent };